@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.buttonContainer {
  text-align: right;
}

.cancel {
  margin-right: variables.$std-margin-md;
}
